import apiService from '../../utils/api';

const FetchUserDetails = async () => {
  try {
    const response = await apiService.fetchData('user-details');
    
    console.log("Fetched User Data Successfully", response);
    
    // Store user details in session storage
    sessionStorage.setItem('user_name', response.user.user_name || '');
    sessionStorage.setItem('user_emailId', response.user.email || '');
    sessionStorage.setItem('user_role', response.user.role || '');
    sessionStorage.setItem('user_id', response.user.user_id || '');
    sessionStorage.setItem('role_id', response.user.role_id|| '');
    sessionStorage.setItem('profile_url', response.user.profile_url || '');
    
    return true; 
  } catch (error) {
    console.error('Error fetching user data:', error);
    return false; 
  }
};

export default FetchUserDetails;